import { useRef, useState, type DragEvent, type ReactNode } from 'react';
import { ACCEPT } from './attach';
import { Icon } from './icons';

/** A drop zone: drag files onto it, or click (or press Enter) to choose. The parent uploads what lands. */
export function FileDrop({ onFiles, label = 'Drop files here, or click to choose', hint, compact, accept = ACCEPT }: { onFiles: (files: File[]) => void; label?: string; hint?: ReactNode; compact?: boolean; accept?: string }) {
  const ref = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const drop = (e: DragEvent) => { e.preventDefault(); setOver(false); const fs = Array.from(e.dataTransfer?.files ?? []).filter((f) => f.size > 0); if (fs.length) onFiles(fs); };
  return (
    <div className={`dropzone${over ? ' over' : ''}${compact ? ' compact' : ''}`} role="button" tabIndex={0} aria-label={label}
      onClick={() => ref.current?.click()} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ref.current?.click(); } }}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={drop}>
      <Icon name="clip" className="ico" />
      <div><b>{label}</b>{hint && <div className="small muted">{hint}</div>}</div>
      <input ref={ref} type="file" multiple accept={accept} hidden onChange={(e) => { if (e.target.files?.length) onFiles(Array.from(e.target.files)); e.target.value = ''; }} />
    </div>
  );
}
